import React from "react";
import { Link } from "react-router-dom";
import { InstagramLogo, FacebookLogo, Phone, EnvelopeSimple, MapPin } from "@phosphor-icons/react";
import { BRAND, NAV_LINKS } from "../lib/data";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="bg-brand-primary text-[#E8E4D7] mt-24">
            <div className="max-w-7xl mx-auto px-4 sm:px-8 py-20 grid lg:grid-cols-12 gap-12">
                <div className="lg:col-span-5">
                    <div className="flex items-center gap-3 mb-6">
                        <img
                            src={BRAND.logoDark}
                            alt={BRAND.name}
                            className="h-16 w-16 object-contain"
                            style={{ mixBlendMode: "screen" }}
                        />
                        <div>
                            <h3 className="font-serif text-2xl text-white font-semibold leading-none">{BRAND.short}</h3>
                            <p className="text-xs uppercase tracking-[0.2em] text-brand-secondary mt-1">Landscape & Hardscape Specialists</p>
                        </div>
                    </div>
                    <p className="text-[#C9C7B9] leading-relaxed max-w-md">
                        Designing, building, and maintaining premium outdoor spaces across Arlington, Falls Church, and the greater DMV since {BRAND.established}.
                    </p>
                    <div className="flex gap-3 mt-6">
                        <a href={BRAND.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="p-2.5 rounded-full bg-white/10 hover:bg-white/20 transition-colors">
                            <InstagramLogo size={20} />
                        </a>
                        <a href={BRAND.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="p-2.5 rounded-full bg-white/10 hover:bg-white/20 transition-colors">
                            <FacebookLogo size={20} />
                        </a>
                    </div>
                </div>

                <div className="lg:col-span-3">
                    <h4 className="text-xs uppercase tracking-[0.2em] text-brand-secondary mb-5">Explore</h4>
                    <ul className="space-y-3">
                        {NAV_LINKS.map((l) => (
                            <li key={l.to}>
                                <Link to={l.to} className="text-[#C9C7B9] hover:text-white transition-colors" data-testid={`footer-nav-${l.label.toLowerCase()}`}>
                                    {l.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="lg:col-span-4">
                    <h4 className="text-xs uppercase tracking-[0.2em] text-brand-secondary mb-5">Contact</h4>
                    <ul className="space-y-4 text-[#C9C7B9]">
                        <li className="flex items-start gap-3">
                            <MapPin size={20} weight="duotone" className="mt-0.5 shrink-0 text-brand-secondary" />
                            <span>{BRAND.address}</span>
                        </li>
                        <li className="flex items-center gap-3">
                            <Phone size={20} weight="duotone" className="shrink-0 text-brand-secondary" />
                            <div className="flex flex-col">
                                <a href={`tel:${BRAND.officePhone.replace(/\D/g, "")}`} className="hover:text-white">Office: {BRAND.officePhone}</a>
                                <a href={`tel:${BRAND.cellPhone.replace(/\D/g, "")}`} className="hover:text-white">Cell: {BRAND.cellPhone}</a>
                            </div>
                        </li>
                        <li className="flex items-center gap-3">
                            <EnvelopeSimple size={20} weight="duotone" className="shrink-0 text-brand-secondary" />
                            <a href={`mailto:${BRAND.email}`} className="hover:text-white break-all">{BRAND.email}</a>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-white/10">
                <div className="max-w-7xl mx-auto px-4 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#C9C7B9]">
                    <p>© {new Date().getFullYear()} {BRAND.name}. All rights reserved.</p>
                    <p>Serving the DMV with care since {BRAND.established}.</p>
                </div>
            </div>
        </footer>
    );
}
